import { render, staticRenderFns } from "./video_tutorial.vue?vue&type=template&id=6150f708&"
import script from "./video_tutorial.vue?vue&type=script&lang=js&"
export * from "./video_tutorial.vue?vue&type=script&lang=js&"
import style0 from "./video_tutorial.vue?vue&type=style&index=0&id=6150f708&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports